import { Injectable } from '@angular/core';
import { AlertController, Loading, LoadingController, ToastController } from 'ionic-angular';

@Injectable()
export class ConfigurationProvider {
  loading: Loading = null;

  constructor(
    private alertCtrl: AlertController,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController) {
  }

  dismissLoading() {
    this.loading.dismiss();
  }

  fixDecimals(val: number) {
    return Math.round(val * 100) / 100;
  }

  formatDate(date: Date, includeDayOfWeek: boolean = false) {
    var objDate = date,
      weekday = new Array('Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'),
      dayOfWeek = weekday[objDate.getDay()],
      dayOfMonth = today + (objDate.getDate() < 10) ? '0' + objDate.getDate() : objDate.getDate(),
      curMonth = objDate.getMonth() + 1,
      monthOfYear = curMonth < 10 ? '0' + curMonth : curMonth,
      curYear = objDate.getFullYear();
    var today = `${includeDayOfWeek ? dayOfWeek + ' ' : ''}${monthOfYear}/${dayOfMonth}/${curYear}`;
    return today;
  }

  generateQuickGuid() {
    return Math.random().toString(36).substring(2, 15) + 
      Math.random().toString(36).substring(2, 15);
  }

  getNutritionTarget(weight: number, height: number, age: number) {

    // calculates calories to maintain weight (no gain or loss)
    let calories = this.CalculateCalories(weight, height, age);

    // TODO: come from database?
    // Endomorph
    // const ratios = {
    //   fat: .35,
    //   carbs: .25,
    //   protein: .4
    // };

    // fat loss = (maintenance - 20%)
    // calories -= calories * .2;

    // return {
    //   Calories: this.fixDecimals(calories),
    //   Fat: this.fixDecimals(calories * ratios.fat / 9),
    //   Carbohydrates: this.fixDecimals(calories * ratios.carbs / 4),
    //   Protein: this.fixDecimals(calories * ratios.protein / 4)
    // };

    // v2
    const protein = this.fixDecimals(weight * 1.25);
    const calsRemaining = (calories - (protein * 4)) / 2;
    return {
      Calories: this.fixDecimals(calories),
      Protein: this.fixDecimals(protein),
      Fat: this.fixDecimals(calsRemaining / 9),
      Carbohydrates: this.fixDecimals(calsRemaining / 4)
    };
  }
  
  getNutritionTargetPercent(current, target) {
    return {
      Calories: this.fixDecimals(current.Calories * 100 / target.Calories),
      Fat: this.fixDecimals(current.Fat * 100 / target.Fat),
      Carbohydrates: this.fixDecimals(current.Carbohydrates * 100 / target.Carbohydrates),
      Protein: this.fixDecimals(current.Protein * 100 / target.Protein)
    };
  }

  getMacroTargetPercent(current) {
    return {
      Calories: this.fixDecimals(current.Calories),
      Fat: this.fixDecimals(current.Fat * 9 * 100 / current.Calories) || 0,
      Carbohydrates: this.fixDecimals(current.Carbohydrates * 4 * 100 / current.Calories) || 0,
      Protein: this.fixDecimals(current.Protein * 4 * 100 / current.Calories) || 0
    };
  }

  pad(n, width = 2, z = '0') {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  }

  showAlert(title, subTitle) {
    let alert = this.alertCtrl.create({
      title: title,
      subTitle: subTitle,
      buttons: ['OK']
    });
    alert.present();
  }

  showLoading(message: string = 'Loading...') {
    this.loading = this.loadingCtrl.create({
      content: message
    });
    this.loading.present();
  }

  showToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'bottom',
      showCloseButton: true
    });
    toast.present();
  }

  uuidv4() {
    // http://www.ietf.org/rfc/rfc4122.txt
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    var uuid = s.join("");
    return uuid;
  }

  private CalculateCalories(weight: number, height: number, age: number) {
    // Mifflin – St Jeor Formula
    return (9.99 * weight + (6.25 * height) - (4.92 * age) + 5.0) * 1.25;
  }

}


// WEBPACK FOOTER //
// ./src/providers/configuration/configuration.ts